//=====================================================
//　タイル型ボタン
//=====================================================
interface IFProps {
    title: string,
    iconfont: string,
    onClick: () => void,
    text?: string,
}    

export function BtnTile(props: IFProps){

    return (
        <button onClick={props.onClick} className="btn-tile btn-first_visit">
            <p className="btn-tile-icon"><span className={"icon " + props.iconfont}></span></p>
            <p className="btn-tile-title text-l text-multiline">{props.title}</p>
            {props.text &&
                <p className="btn-tile-text">
                    {props.text}
                </p>
            } 
        </button>
    )

}